import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, catchError } from 'rxjs';
import { DataService } from '../data.service';
import { StateCountry, Organization } from 'src/app/shared/common-components/common-structure';
import { LoggerService } from '../../shared/common-components/logger.service';
@Injectable({
    providedIn: 'root'
})

export class CarrierProfileService extends DataService {

    private baseURI = this.apiUri + '/carrierprofile/';
    private observable$: any;
    private _logger: LoggerService;

    constructor(http: HttpClient, logger: LoggerService) {
        super(http);
        this._logger = logger;
    }

    getOrganization(orgId: string): Observable<any> {
        this.setUri(this.baseURI + orgId + '/orgId');
        return this.get();
    }
    getAll(): Observable<any> {
        this.setUri(this.baseURI);
        return this.get();
    }

    saveOrganization(organization: Organization): Observable<any> {
        this.setUri(this.apiUri + '/carrierprofile/organizationSave');
        return this.update(organization);
    }

    deleteOrganization(orgId: string): Observable<any> {
        this.setUri(this.baseURI + 'organizationDelete/' + orgId + '/orgId');
        return this.get();
    }

    deleteOrganizationWithMessage(deleteCarrierMappingEntity: string): Observable<any> {
      return this.http.put<any>(this.baseURI + 'tspdelete',
        deleteCarrierMappingEntity,
        {headers: new HttpHeaders({'Content-Type': 'application/json'})});
    }

    deleteCarrierApprovalWithMessage(deleteApprovalCarrierMappingEntity: string): Observable<any> {
      return this.http.put<any>(this.baseURI + 'tspapprovaldelete',
        deleteApprovalCarrierMappingEntity,
        {headers: new HttpHeaders({'Content-Type': 'application/json'})});
    }

    reactivateTsp(organization: Organization): Observable<any> {
        this.setUri(this.apiUri + '/carrierprofile/reactivate');
        return this.update(organization);
    }

    getAllStates(stateCountryType): Observable<[StateCountry]> {
        this.setUri(this.baseURI + stateCountryType + 'statecountrytype');
        this.observable$ = this.http.get(this.baseURI + stateCountryType + '/statecountrytype').pipe(catchError(this.handleError));
        return this.observable$;
    }

    getStateCountryId(stateCountryCode): Observable<any> {
        this.setUri(this.baseURI + stateCountryCode + 'stateCountryCode');
        this.observable$ = this.http.get(this.baseURI + stateCountryCode + '/stateCountryCode').pipe(catchError(this.handleError));
        return this.observable$;
    }

    checkExistingScac(scacCode, businessType): Observable<any> {
        this.setUri(this.baseURI + scacCode + '/scacCode');
        this.observable$ = this.http.get(this.baseURI + scacCode + '/scacCode/' + businessType ).pipe(catchError(this.handleError));
        return this.observable$;
    }

}
